import { useState, useEffect, useCallback } from 'react';
import { IVideoClip, VideoClipQuery, PaginationQuery } from '@packages/global';
import { episodeApi } from '../services/user/episode.api';
import { videoClipApi } from '../services/user/videoclip.api';


export function useEpisodeVideoClips(episodeId?: string | null) {
  const [videoClips, setVideoClips] = useState<IVideoClip[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // 用 useCallback 稳定函数引用，避免每次父组件渲染都生成新函数，
  // 进而导致下游（如无限画布的 actions / 重建 effect）频繁失效重算。
  const fetchVideoClips = useCallback(async () => {
    if (!episodeId) return;

    setLoading(true);
    setError(null);

    try {
      const clips = await episodeApi.getEpisodeVideoClips(episodeId);
      setVideoClips(clips);
    } catch (err) {
      setError('加载视频片段失败');
      console.error('Failed to fetch video clips:', err);
    } finally {
      setLoading(false);
    }
  }, [episodeId]);

  useEffect(() => {
    fetchVideoClips();
  }, [fetchVideoClips]);

  const updateVideoClip = useCallback((updatedClip: IVideoClip) => {
    setVideoClips(prev => prev.map(clip =>
      clip.id === updatedClip.id ? updatedClip : clip
    ));
  }, []);

  const refreshVideoClip = useCallback(async (clipId: string) => {
    try {
      const updatedClip = await videoClipApi.getVideoClip(clipId);
      updateVideoClip(updatedClip);
    } catch (err) {
      console.error('Failed to refresh video clip:', err);
    }
  }, [updateVideoClip]);

  return {
    videoClips,
    loading,
    error,
    refetch: fetchVideoClips,
    updateVideoClip,
    refreshVideoClip
  };
}
